module.exports = new __parcel__URL__("EURCLogo.3ca41448.svg").toString();